import { formatMoney } from '../../../helpers/utils'

export const resolveFillRateProductDisplayDifference = (value) =>
  -Number(value || 0)

export const resolveFillRateProductSummaryDifference = (value) =>
  Math.abs(Number(value || 0))

export const getFillRateProductDifferenceTone = (value) => {
  const amount = resolveFillRateProductDisplayDifference(value)

  if (amount > 0) return 'positive'
  if (amount < 0) return 'negative'
  return 'neutral'
}

export const formatFillRateProductTableDifference = (
  value,
  { zeroAsDash = true } = {}
) => {
  const amount = resolveFillRateProductDisplayDifference(value)

  if (amount === 0) return zeroAsDash ? '-' : formatMoney(0)
  if (amount > 0) return formatMoney(amount)

  return `-${formatMoney(Math.abs(amount))}`
}

export const formatFillRateProductSummaryDifference = (value) =>
  formatFillRateProductTableDifference(value, { zeroAsDash: false })
